import { Button, css, styled } from 'canoe';
import React, { useRef } from 'react';
import { Card } from 'styleguide';

import { DocumentPreview } from '@candu-ai/document/preview';
import { useToggle } from 'commons/hooks';
import { Ellipsis, Redo, Trash } from 'styleguide/icons';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  height: 260px;
  padding: 0;
  position: relative;
  width: 308px;
`;

const Options = styled.div`
  cursor: pointer;
  position: absolute;
  right: 10px;
  transition: opacity 0.5s;
  top: 10px;
  z-index: 2;
`;

const OptionsContainer = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.OnyxGrayD10};
    border-radius: 4px;
    position: absolute;
    overflow: hidden;
    right: 0;
    z-index: 2;
  `}
`;

const OptionsButton = styled(Button)`
  ${({ theme }) => css`
    border: none;
    border-radius: 0;
    color: ${theme.colors.White};
    justify-content: space-between;
    white-space: nowrap;

    span {
      margin-right: ${theme.spaces.xs};
    }
  `}
`;

const Transform = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 6px;
`;

const DocumentContainer = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 40px;
  position: relative;
  z-index: 1;
`;

interface Props {
  archiveDocumentId: number;
  documentId: number;
  applicationId: string;
  onDeleteDocument: (archiveDocumentId: number) => void;
  onRestoreDocument: (archiveDocumentId: number) => void;
}

const ArchivedDocumentCard = ({
  archiveDocumentId,
  documentId,
  applicationId,
  onRestoreDocument,
  onDeleteDocument,
}: Props) => {
  const optionEl = useRef(null);
  const [isOpen, toggle] = useToggle(false);

  return (
    <StyledCard>
      <Options ref={optionEl}>
        <Ellipsis onClick={toggle} color="neutral" shade={2} vertical />
        {isOpen && (
          <OptionsContainer onMouseLeave={toggle}>
            <OptionsButton
              fullWidth
              variant="contrast"
              onClick={() => onDeleteDocument(archiveDocumentId)}
            >
              <Trash color="white" /> Delete
            </OptionsButton>
            <OptionsButton
              fullWidth
              variant="contrast"
              onClick={() => onRestoreDocument(archiveDocumentId)}
            >
              <Redo color="white" /> Restore
            </OptionsButton>
          </OptionsContainer>
        )}
      </Options>

      <DocumentContainer>
        <Transform>
          {/* TODO: look into getting a version id for the document here */}
          <DocumentPreview applicationId={applicationId} documentId={documentId} />
        </Transform>
      </DocumentContainer>
    </StyledCard>
  );
};

export default ArchivedDocumentCard;
